import { render, staticRenderFns } from "./single_side.vue?vue&type=template&id=8d9a9fde"
import script from "./single_side.vue?vue&type=script&lang=js"
export * from "./single_side.vue?vue&type=script&lang=js"
import style0 from "./single_side.vue?vue&type=style&index=0&id=8d9a9fde&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports